export default __webpack_public_path__ + "static/media/autoform-unselected.6b83872c.png";